import { api } from '../api';
import LanguagesEndpoints from './i18n.endpoints';
import { GetLanguagesResponseData, LanguagesRequest } from './i18n.types';

const enhancedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLanguages: build.query<GetLanguagesResponseData, LanguagesRequest>({
      query: (language) => `${LanguagesEndpoints.Languages}/${language}`,
    }),
  }),
});

export const { useGetLanguagesQuery } = enhancedApi;
